import { cn } from "@/lib/utils"
import { PropsWithChildren } from "react"

export interface OutlinePillProps {
  className?: string
}

export const OutlinePill = ({ children, className }: PropsWithChildren<OutlinePillProps>) => {
  return (
    <p className={cn('border border-primary-500 rounded-sm text-xs font-normal text-primary-500 px-2 py-1 overflow-hidden whitespace-nowrap text-ellipsis', className)}>
      {children}
    </p>
  )
}